import { UPLOADS_PATH } from '../config/keys'

export const getFullPath = (
  entity: 'plans' | 'types' | 'brands' = 'brands',
  name?: string
) => {
  if (!name) return ''
  const trimmed = name.trim()
  if (!trimmed) return ''
  if (/^https?:\/\//i.test(trimmed)) return trimmed
  if (trimmed.startsWith('/')) return trimmed
  return `${UPLOADS_PATH}/${entity}/${trimmed}`
}
